import MOSelectAllButton from './MOSelectAllButton.js'
import {referenceIDListSelector} from './moListSelectors.js'
import Row from './Row.js'
import EmptyList from './EmptyList.js'
import {useSelector} from '../../store.js'

export default function Table() {
  const referenceIDList = useSelector(referenceIDListSelector)

  return (
    <table className="table table--zebra-list table--product-list">
      <thead>
        <tr className="table__tr">
          <th className="table__th table__th--sm v-align-middle no-border table__th--order-checkbox">
            <MOSelectAllButton />
          </th>
          <th className="table__th table__th--sm th-width-25 v-align-middle no-border">
            MFG Order ID
          </th>
          <th className="table__th table__th--sm th-width-35 v-align-middle no-border">
            Contents
          </th>
          <th className="table__th table__th--sm th-width-20 v-align-middle no-border">
            Assigned Warehouse
          </th>

          <th className="table__th table__th--sm th-width-15 v-align-middle no-border">
            Date Created
          </th>
          <th className="table__th table__th--sm v-align-middle no-border" />
        </tr>
      </thead>
      <tbody className="table__tbody--full-border">
        {referenceIDList.map((referenceID) => (
          <Row key={referenceID} referenceID={referenceID} />
        ))}
        {referenceIDList.length === 0 && <EmptyList colSpan="7" />}
      </tbody>
    </table>
  )
}
